// some versions of angular don't export the angular module properly,
// so we get it from window in this case.
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var angular = require('angular');

/* istanbul ignore next */
if (!angular.version) {
  angular = window.angular;
}
exports['default'] = angular;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./angular-fix/index.js
 **/